import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CommandCenter from "@/pages/CommandCenter";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import Leads from "@/pages/Leads";
import Opportunities from "@/pages/Opportunities";
import Pipeline from "@/pages/Pipeline";
import Activities from "@/pages/Activities";
import Campaigns from "@/pages/Campaigns";
import Projects from "@/pages/Projects";
import Clients from "@/pages/Clients";
import Settings from "@/pages/Settings";
import ImportCenter from "@/pages/ImportCenter";
import CalendarPage from "@/pages/Calendar";
import ComingSoon from "@/pages/ComingSoon";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen flex items-center justify-center text-slate-400 font-heading">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/command-center" element={<CommandCenter />} />
              <Route path="/aziende" element={<Companies />} />
              <Route path="/aziende/:id" element={<CompanyDetail />} />
              <Route path="/contatti" element={<Contacts />} />
              <Route path="/contatti/:id" element={<ContactDetail />} />
              <Route path="/lead" element={<Leads />} />
              <Route path="/opportunita" element={<Opportunities />} />
              <Route path="/pipeline" element={<Pipeline />} />
              <Route path="/attivita" element={<Activities />} />
              <Route path="/campagne" element={<Campaigns />} />
              <Route path="/progetti" element={<Projects />} />
              <Route path="/clienti" element={<Clients />} />
              <Route path="/import" element={<ImportCenter />} />
              <Route path="/calendario" element={<CalendarPage />} />
              <Route path="/import/:batchId" element={<ImportCenter />} />
              <Route path="/documenti" element={<ComingSoon title="Documenti" phase="Fase 2" />} />
              <Route path="/report" element={<ComingSoon title="Report & Analytics" phase="Fase 2" />} />
              <Route path="/ai-assistant" element={<ComingSoon title="F&P AI Assistant" phase="Fase 3" />} />
              <Route path="/automazioni" element={<ComingSoon title="Automazioni" phase="Fase 3" />} />
              <Route path="/impostazioni" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
